export function randomSymbol (symbols) {
    let result;
    let count = 0;
    for (let prop in symbols)
        if (Math.random() < 1 / ++count)
            result = prop;
    return symbols[result];
}